import DocumentPreview from "../Common/DocumentPreview";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import AuthService from "../../Services/AuthService";
import { ToastContainer, toast } from "react-toastify";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ProfileEdit.css";
import { SquarePlus, X } from 'lucide-react';
import { validateFileSize, normalizeUploadResponse } from "../../utils/uploadUtils";
const ProfileEdit = () => {
  // Initialize userData with default values to prevent undefined errors
  const [userData, setUserData] = useState({
    civilEng_id: "",
    name: "",
    firstName: "",
    middleName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    image: "",
    Personal_Details: [
      {
        name: "",
        age: "",
        gender: "",
        universityName: "",
        passedOutYear: "",
      },
    ],
    Personal_Address: [
      {
        address: "",
        pincode: "",
      },
    ],
    Office_Address: [
      {
        Designation: "",
        businessType: "",
        bussinessAddress: "",
        bussinessTitle: "",
        occupation: "",
        organisationName: "",
        years: "",
      },
    ],
    FamilyHistory: [
      {
        reference1: { name: "", relation: "", phone: "", address: "" },
        reference2: { name: "", relation: "", phone: "", address: "" },
      },
    ],
    PreferredRegions: [{ pincode: "", region: "" }],
    videoTutorial: { videoTutorial: false, date: "", joinning: "" },
    WillingnessToWork: false,
    submit_to_DoCity_with_sincerity_and_honesty: false,
    docs: [],
  });
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [userImage, setUserImage] = useState("");
  const imageInputRef = useRef(null);

  const [monthError, setMonthError] = useState("");
  const [yearError, setYearError] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [error, setError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [uploadFileLoader, setUploadFileLoader] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [page, setPage] = useState("page1");
  const [formError, setFormError] = useState("");

  const fileInputRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("userDetails"));
    if (storedUser?.image) {
      setUserImage(storedUser.image);
    }
  }, []);

  useEffect(() => {
    const getData = JSON.parse(localStorage.getItem("userDetails"));
    getUserInformation();

    if (getData) {
      // Merge with default state to ensure all fields exist
      // setUserData((prev) => ({
      //   ...prev,
      //   ...getData,
      //   Personal_Details: getData.Personal_Details?.length
      //     ? getData.Personal_Details
      //     : prev.Personal_Details,
      //   Personal_Address: getData.Personal_Address?.length
      //     ? getData.Personal_Address
      //     : prev.Personal_Address,
      //   Office_Address: getData.Office_Address?.length
      //     ? getData.Office_Address
      //     : prev.Office_Address,
      //   FamilyHistory: getData.FamilyHistory?.length
      //     ? getData.FamilyHistory
      //     : prev.FamilyHistory,
      //   PreferredRegions: getData.PreferredRegions?.length
      //     ? getData.PreferredRegions
      //     : prev.PreferredRegions,
      //   videoTutorial: getData.videoTutorial || prev.videoTutorial,
      //   docs: getData.docs || []
      // }));
      setUploadedFiles(getData?.docs || []);
    }
  }, []);

  const handleProfileImageClick = () => {
    imageInputRef.current.click();
  };

  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const sizeError = validateFileSize(file);
    if (sizeError) {
      toast.error(sizeError);
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    try {
      setIsLoading(true);

      const response = await AuthService.handleFileUpload(formData);
      const imageUrl = normalizeUploadResponse(response);

      if (!imageUrl) {
        toast.error("Upload failed. Please try again.");
        return;
      }

      setUserImage(imageUrl);

    } catch (err) {
      console.error(err);
      toast.error("Something went wrong while uploading");
    } finally {
      setIsLoading(false);
      e.target.value = "";
    }
  };

  const getUserInformation = async () => {
    const getData = JSON.parse(localStorage.getItem("userDetails"));

    let obj = {
      userId: getData.civilEng_id,
    };
    const getUserInformation = await AuthService.getUserInformation(obj);
    setUploadedFiles(getUserInformation.data?.docs || []);
    const splitData = (getUserInformation?.data?.Personal_Details[0]?.passedOutYear || "").split('/');
    if (splitData) {
      setMonth(splitData[0])
      setYear(splitData[1])
    }
    setUserData(getUserInformation.data);
  };
  // Unified change handler with validation
  const blockedDomains = [
    "mail.com"
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    if (name === "Personal_Address.pincode") {
      const cleanPin = value.replace(/\D/g, "").slice(0, 6);

      setUserData((prev) => ({
        ...prev,
        Personal_Address: [
          {
            ...prev.Personal_Address[0],
            pincode: cleanPin,
          },
        ],
      }));

      if (!cleanPin) {
        setError((prev) => ({
          ...prev,
          "Personal_Address.pincode": "Pincode is required",
        }));
      } else if (!/^[1-9]\d{5}$/.test(cleanPin)) {
        setError((prev) => ({
          ...prev,
          "Personal_Address.pincode":
            "Enter a valid 6-digit Indian pincode (cannot start with 0)",
        }));
      } else {
        setError((prev) => ({
          ...prev,
          "Personal_Address.pincode": "",
        }));
      }
      return;
    }

    if (name.includes("reference")) {
      const [refType, field] = name.split(".");
      const refIndex = refType === "reference1" ? "reference1" : "reference2";

      setUserData((prev) => ({
        ...prev,
        FamilyHistory: [
          {
            ...prev.FamilyHistory[0],
            [refIndex]: {
              ...prev.FamilyHistory[0][refIndex],
              [field]: newValue,
            },
          },
        ],
      }));
    }

    else if (name.includes("Office_Address")) {
      const field = name.replace("Office_Address.", "");
      setUserData((prev) => ({
        ...prev,
        Office_Address: [{ ...prev.Office_Address[0], [field]: newValue }],
      }));
    }

    else if (name.includes("Personal_Details")) {
      const field = name.replace("Personal_Details.", "");
      setUserData((prev) => ({
        ...prev,
        Personal_Details: [{ ...prev.Personal_Details[0], [field]: newValue }],
      }));
    }

    else if (name.includes("Personal_Address")) {
      const field = name.replace("Personal_Address.", "");
      setUserData((prev) => ({
        ...prev,
        Personal_Address: [{ ...prev.Personal_Address[0], [field]: newValue }],
      }));
    }

    else if (name.includes("videoTutorial")) {
      const field = name.replace("videoTutorial.", "");
      setUserData((prev) => ({
        ...prev,
        videoTutorial: { ...prev.videoTutorial, [field]: newValue },
      }));
    }

    else {
      setUserData((prev) => ({ ...prev, [name]: newValue }));
    }

    if (!newValue && type !== "checkbox") {
      setError((prev) => ({ ...prev, [name]: "This field is required" }));
      return;
    } else {
      setError((prev) => ({ ...prev, [name]: "" }));
    }

    if (name === "email") {
      const emailRegex =
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

      if (!emailRegex.test(value)) {
        setError((prev) => ({
          ...prev,
          email: "Enter a valid email address",
        }));
        return;
      }

      const domain = value.split("@")[1]?.toLowerCase();
      if (blockedDomains.includes(domain)) {
        setError((prev) => ({
          ...prev,
          email: "Personal email domains are not allowed",
        }));
        return;
      }

      setError((prev) => ({ ...prev, email: "" }));
    }

    if (name === "phoneNumber") {
      const phone = value.replace(/\D/g, "").slice(0, 10);

      if (!/^[6-9]\d{9}$/.test(phone)) {
        setError((prev) => ({
          ...prev,
          phoneNumber: "Enter a valid 10-digit Indian phone number",
        }));
      } else {
        setError((prev) => ({ ...prev, phoneNumber: "" }));
      }
    }
  };




  const handlePreferredRegionsChange = (e, index) => {
    const { name, value } = e.target;
    const field = name.includes("pincode") ? "pincode" : "region";
    setUserData((prev) => {
      const updatedRegions = [...prev.PreferredRegions];
      updatedRegions[index] = {
        ...updatedRegions[index],
        [field]: value,
      };
      return { ...prev, PreferredRegions: updatedRegions };
    });
  };

  const handleRemoveRegion = (index) => {
    setUserData((prev) => ({
      ...prev,
      PreferredRegions: prev.PreferredRegions.filter((_, i) => i !== index),
    }));
  };

  const nextPage = () => {
    let errors = {};

    // if (page === "page1") {
    //   if (!userData.name?.trim()) errors.name = "Full name is required";
    //   if (!userData.image) errors.image = "Profile image is required";
    // }
    if (page === "page1") {
      if (!userData.name || userData.name.trim() === "") {
        errors.name = "Username is required";
      }
      if (!userData.firstName || userData.firstName.trim() === "") {
        errors.firstName = "First name is required";
      }
      if (!userData.lastName || userData.lastName.trim() === "") {
        errors.lastName = "Last name is required";
      }

      if (!userData.phoneNumber || !/^\d{10}$/.test(userData.phoneNumber)) {
        errors.phoneNumber = "Valid 10-digit phone number is required";
      }

      if (!userData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email)) {
        errors.email = "Valid email is required";
      }


      if (
        !userData?.Personal_Address?.[0]?.address ||
        userData.Personal_Address[0].address.trim() === ""
      ) {
        errors["Personal_Address.address"] = "Address is required";
      }

      if (
        !userData?.Personal_Address?.[0]?.pincode ||
        !/^[1-9]\d{5}$/.test(userData.Personal_Address[0].pincode)
      ) {
        errors["Personal_Address.pincode"] =
          "Enter a valid Indian pincode (6 digits, cannot start with 0)";
      }

    }


    if (page === "page2") {
      const personal = userData?.Personal_Details?.[0] || {};
      const splitData = (personal.passedOutYear || "").split('/');
      console.log(splitData, 'splitData');
      if (!splitData[0] || !splitData[1] || !splitData[0].trim() || !splitData[1].trim()) {
        errors.passedOutYear = "Month and Year are required";
      }
      if (!personal.universityName?.trim())
        errors["Personal_Details.universityName"] = "University name is required";

      const today = new Date().getFullYear();
      const yeardata = personal.passedOutYear.split('/')[1]
      if (!personal.passedOutYear)
        errors["Personal_Details.passedOutYear"] = "Passed out year is required";
      else if (yeardata > today)
        errors["Personal_Details.passedOutYear"] = "Date cannot be in the future";

      // if (!address.address?.trim())
      //   errors["Personal_Address.address"] = "Address is required";
      // if (
      //   !userData.aadharNumber ||
      //   !/^\d{12}$/.test(userData.aadharNumber.toString())
      // ) {
      //   errors.aadharNumber = "Valid 12-digit Aadhar number is required";
      // }
      if (!personal.age)
        errors["Personal_Details.age"] = "Age is required";
      else if (Number(personal.age) < 18)
        errors["Personal_Details.age"] = "Minimum age is 18";

      if (!personal.gender)
        errors["Personal_Details.gender"] = "Gender is required";
    }

    if (page === "page3") {
      const office = userData?.Office_Address?.[0] || {};

      if (!office.occupation)
        errors["Office_Address.occupation"] = "Occupation is required";
      else if (office.occupation === "salaried") {
        if (!office.Designation)
          errors["Office_Address.Designation"] = "Designation is required";
        if (!office.organisationName)
          errors["Office_Address.organisationName"] = "Organization name is required";
      } else if (office.occupation === "selfEmployed") {
        if (!office.bussinessTitle)
          errors["Office_Address.bussinessTitle"] = "Business title is required";
        if (!office.businessType)
          errors["Office_Address.businessType"] = "Business type is required";
        if (!office.bussinessAddress)
          errors["Office_Address.bussinessAddress"] = "Business address is required";
      }
    }

    if (page === "page4") {
      const ref1 = userData?.FamilyHistory?.[0]?.reference1 || {};
      const ref2 = userData?.FamilyHistory?.[0]?.reference2 || {};

      if (!ref1.name || !ref1.relation || !ref1.phone || !ref1.address)
        errors["reference1"] = "All family reference fields are required";
      else if (!/^\d{10}$/.test(ref1.phone))
        errors["reference1.phone"] = "Family reference phone must be 10 digits";

      if (!ref2.name || !ref2.relation || !ref2.phone || !ref2.address)
        errors["reference2"] = "All government reference fields are required";
      else if (!/^\d{10}$/.test(ref2.phone))
        errors["reference2.phone"] = "Government reference phone must be 10 digits";
    }
    if (page === "page5") {
      const regions = userData?.PreferredRegions || [];

      if (regions.length === 0) {
        errors.PreferredRegions = "At least one preferred region is required";
      } else {
        regions.forEach((region, index) => {
          const pin = region.pincode?.toString().trim();
          const reg = region.region?.trim();

          if (!pin || !/^[1-9]\d{5}$/.test(pin)) {
            errors[`PreferredRegions[${index}].pincode`] =
              `Enter a valid Indian pincode at row ${index + 1} (cannot start with 0)`;
          }

          if (!reg) {
            errors[`PreferredRegions[${index}].region`] =
              `Region name is required at row ${index + 1}`;
          }
        });
      }
    }


    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach((err) => toast.error(err));
      return;
    }

    if (page === "page1") setPage("page2");
    else if (page === "page2") setPage("page3");
    else if (page === "page3") setPage("page4");
    else if (page === "page4") setPage("page5");
    else if (page === "page5") setPage("page6");
  };


  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const sizeError = validateFileSize(file);
    if (sizeError) {
      toast.error(sizeError);
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    setUploadFileLoader(true);
    try {
      const response = await AuthService.handleFileUpload(formData);
      const fileUrl = normalizeUploadResponse(response);

      if (!fileUrl) {
        toast.error("Upload failed. Please try again.");
        return;
      }

      const docObj = {
        userId: userData.civilEng_id,
        docType: `Civil Engineer Doc ${uploadedFiles.length + 1}`,
        docUrl: fileUrl,
      };

      console.timeLog(docObj, "docObj");
      const addDocResponse = await AuthService.addDocument(docObj);
      if (addDocResponse.message === "Success") {
        setUploadedFiles((prev) => [...prev, addDocResponse.data[0]]);
      }
    } catch (err) {
      toast.error("Failed to upload document");
    } finally {
      setUploadFileLoader(false);
      if (fileInputRef.current) {
        fileInputRef.current.value = ""; 
      }
    }
  };
  // const steps = [
  //   { id: 1, title: 'Personal Details', completed: currentStep > 1 },
  //   { id: 2, title: 'Agency Details', completed: currentStep > 2 },
  //   { id: 3, title: 'Contact Person Details', completed: currentStep > 3 },
  //   { id: 4, title: 'Work Order Scope', completed: currentStep > 4 }
  // ];

  // Remove an uploaded file
  const handleRemove = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const editUser = async (e) => {
    e.preventDefault();
    const errors = {};
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^\S+@\S+\.\S+$/;
    const pincodeRegex = /^\d{6}$/;
    const {
      name,
      phoneNumber,
      email,
      Personal_Details = [{}],
      Personal_Address = [{}],
      FamilyHistory = [{}],
      PreferredRegions = [],
    } = userData;
    const [personalDetails] = Personal_Details;
    const [personalAddress] = Personal_Address;
    const [family] = FamilyHistory;
    const reference1 = family.reference1 || {};
    const reference2 = family.reference2 || {};
    const today = new Date().getFullYear();
    const yeardata = personalDetails.passedOutYear.split('/')[1]

    if (!name) errors.name = "Username is required";
    if (!userData.firstName) errors.firstName = "First name is required";
    if (!userData.lastName) errors.lastName = "Last name is required";
    if (!phoneNumber) errors.phoneNumber = "Phone number is required";
    else if (!phoneRegex.test(phoneNumber))
      errors.phoneNumber = "Phone number must be 10 digits";
    if (!email) errors.email = "Email is required";
    else if (!emailRegex.test(email)) errors.email = "Invalid email format";
    // if (!aadharNumber) errors.aadharNumber = "Aadhar number is required";
    // else if (!aadharRegex.test(aadharNumber))
    //   errors.aadharNumber = "Aadhar must be 12 digits";
    if (!personalDetails.age)
      errors["Personal_Details.age"] = "Age is required";
    else if (personalDetails.age < 18)
      errors["Personal_Details.age"] = "Minimum age is 18";
    if (!personalDetails.gender)
      errors["Personal_Details.gender"] = "Gender is required";
    if (!personalDetails.universityName)
      errors["Personal_Details.universityName"] = "University name is required";
    if (!yeardata)
      errors["Personal_Details.passedOutYear"] = "Passed out year is required";
    else if (yeardata > today)
      errors["Personal_Details.passedOutYear"] = "Date cannot be in the future";
    if (!personalAddress.address)
      errors["Personal_Address.address"] = "Address is required";
    if (!personalAddress.pincode)
      errors["Personal_Address.pincode"] = "Pincode is required";
    else if (!pincodeRegex.test(personalAddress.pincode))
      errors["Personal_Address.pincode"] = "Pincode must be 6 digits";
    if (!reference1.name)
      errors["reference1.name"] = "Reference 1 name is required";
    if (!reference1.relation)
      errors["reference1.relation"] = "Reference 1 relation is required";
    if (!reference1.phone)
      errors["reference1.phone"] = "Reference 1 phone is required";
    else if (!phoneRegex.test(reference1.phone))
      errors["reference1.phone"] = "Phone must be 10 digits";
    if (!reference1.address)
      errors["reference1.address"] = "Reference 1 address is required";
    if (!reference2.name)
      errors["reference2.name"] = "Reference 2 name is required";
    if (!reference2.relation)
      errors["reference2.relation"] = "Reference 2 relation is required";
    if (!reference2.phone)
      errors["reference2.phone"] = "Reference 2 phone is required";
    else if (!phoneRegex.test(reference2.phone))
      errors["reference2.phone"] = "Phone must be 10 digits";
    if (!reference2.address)
      errors["reference2.address"] = "Reference 2 address is required";
    if (
      reference1.name === reference2.name ||
      reference1.phone === reference2.phone ||
      reference1.relation === reference2.relation ||
      reference1.address === reference2.address
    ) {
      errors["reference2.sameAsReference1"] =
        "Reference 2 should not be same as Reference 1";
    }
    if (PreferredRegions.length === 0) {
      errors["PreferredRegions"] = "At least one preferred region is required";
    } else {
      PreferredRegions.forEach((region, index) => {
        if (!region.pincode) {
          errors[
            `PreferredRegions[${index}].pincode`
          ] = `Pincode is required at row ${index + 1}`;
        } else if (!pincodeRegex.test(region.pincode)) {
          errors[
            `PreferredRegions[${index}].pincode`
          ] = `Pincode must be 6 digits at row ${index + 1}`;
        }
        if (!region.region) {
          errors[
            `PreferredRegions[${index}].region`
          ] = `Region is required at row ${index + 1}`;
        }
      });
    }
    if (!uploadedFiles || uploadedFiles.length === 0) {
      errors.uploadedFiles = "At least one document must be uploaded";
    }
    if (Object.keys(errors).length > 0) {
      console.log(errors, 'errors')
      setError(errors);
      setFormError("Please fill in all required fields before submitting.");
      setTimeout(() => setFormError(""), 3000);
      return;
    } else {
      setIsLoading(true);
      try {


        const payload = {
          userId: userData.civilEng_id,
          ...userData,
          image: userImage,
          docs: uploadedFiles,
        };
        console.log(payload, 'payload')
        const response = await AuthService.updateCivilEngData(payload);
        if (response.message === "Success") {
          localStorage.setItem("userDetails", JSON.stringify(response?.data));
          toast.success("Profile updated successfully");
          setTimeout(() => {
            navigate("/navbar/dashboard");
            window.location.reload();
          }, 1000);
        } else {
          toast.error("Failed to update profile");
        }
      } catch (err) {
        toast.error(
          "Failed to update profile: " +
          (err?.response?.data?.message || err.message || "Unknown error")
        );
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    }
  };
  const scrollRef = useRef(null);
  const scrollAmount = 200;
  const handleMonth = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 2);

    if (value && (value < 1 || value > 12)) {
      setMonthError("Month must be between 01 and 12");
    } else {
      setMonthError("");
    }

    setMonth(value);
    setUserData((prev) => ({
      ...prev,
      Personal_Details: [
        {
          ...prev.Personal_Details[0],
          passedOutYear: `${value}/${year}`,
        },
      ],
    }));
  };

  const handleYear = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 4);
    const currentYear = new Date().getFullYear();

    if (value.length !== 4) {
      setYearError("Year must be 4 digits");
    } else if (value < 1950 || value > currentYear) {
      setYearError(`Year must be between 1950 and ${currentYear}`);
    } else {
      setYearError("");
    }

    setYear(value);
    setUserData((prev) => ({
      ...prev,
      Personal_Details: [
        {
          ...prev.Personal_Details[0],
          passedOutYear: `${month}/${value}`,
        },
      ],
    }));
  };

  const scrollSteps = (direction) => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const offset = direction === "left" ? -scrollAmount : scrollAmount;

    container.scrollBy({
      left: offset,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    const updateArrows = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;

      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft + clientWidth < scrollWidth);
    };

    updateArrows();

    container.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    return () => {
      container.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, []);

  return (
    <div className="container-fluid-civilEng-Profile">
      <div className="row">
        <div className="progress-container">
          {showLeftArrow && (
            <button
              className="scroll-btn left"
              onClick={() => scrollSteps("left")}
            >
              &#8592;
            </button>
          )}

          <div className="progress-steps" ref={scrollRef}>
            <div
              className={`progress-step ${page === "page1" ? "active" : ""}`}
              onClick={() => setPage("page1")}
            >
              Basic Info
            </div>

            <div
              className={`progress-step ${page === "page2" ? "active" : ""}`}
              onClick={() => setPage("page2")}
            >
              Personal Details
            </div>

            <div
              className={`progress-step ${page === "page3" ? "active" : ""}`}
              onClick={() => setPage("page3")}
            >
              Office Details
            </div>

            <div
              className={`progress-step ${page === "page4" ? "active" : ""}`}
              onClick={() => setPage("page4")}
            >
              Family History
            </div>

            <div
              className={`progress-step ${page === "page5" ? "active" : ""}`}
              onClick={() => setPage("page5")}
            >
              Preferred Region
            </div>

            <div
              className={`progress-step ${page === "page6" ? "active" : ""}`}
              onClick={() => setPage("page6")}
            >
              Documents
            </div>
          </div>

          {showRightArrow && (
            <button
              className="scroll-btn right"
              onClick={() => scrollSteps("right")}
            >
              &#8594;
            </button>
          )}
        </div>

        <div className="col-md-12">
          <div className="profile-edit-form">
            <Form onSubmit={editUser}>
              {page === "page1" && (
                <>
                  <div className="section-title">
                    <h3>Basic Information</h3>
                  </div>
                  <div className="profile-image-wrapper">
                    <div
                      className="profile-image-box"
                      onClick={handleProfileImageClick}
                    >
                      <img
                        src={
                          userImage
                            ? userImage
                            : "https://via.placeholder.com/120?text=Upload"
                        }
                        alt="Profile"
                        className="profile-image"
                      />
                      <div className="profile-image-overlay">
                        Change Photo
                      </div>
                    </div>

                    <input
                      type="file"
                      accept="image/*"
                      ref={imageInputRef}
                      style={{ display: "none" }}
                      onChange={handleProfileImageChange}
                    />
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Username</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Username"
                          name="name"
                          value={userData?.name || ""}
                          onChange={handleChange}
                        />
                        {error.name && <p className="error">{error.name}</p>}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">First Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter First Name"
                          name="firstName"
                          value={userData?.firstName || ""}
                          onChange={handleChange}
                        />
                        {error.firstName && <p className="error">{error.firstName}</p>}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Middle Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Middle Name (Optional)"
                          name="middleName"
                          value={userData?.middleName || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Last Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Last Name"
                          name="lastName"
                          value={userData?.lastName || ""}
                          onChange={handleChange}
                        />
                        {error.lastName && <p className="error">{error.lastName}</p>}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">
                          Phone Number
                        </Form.Label>
                        <div className="d-flex align-items-center">
                          <div style={{
                            padding: '0 10px',
                            backgroundColor: '#f3f4f6',
                            border: '1px solid #ced4da',
                            borderRadius: '5px 0 0 5px',
                            borderRight: 'none',
                            color: '#4b5563',
                            fontSize: '1rem',
                            height: '38px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '55px',
                            fontWeight: '500'
                          }}>
                            +91
                          </div>
                          <Form.Control
                            type="number"
                            placeholder="Enter Phone Number"
                            name="phoneNumber"
                            value={userData?.phoneNumber || ""}
                            onChange={handleChange}
                            style={{ borderRadius: '0 5px 5px 0' }}
                          />
                        </div>
                        {error.phoneNumber && (
                          <p className="error">{error.phoneNumber}</p>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          name="email"
                          value={userData?.email || ""}
                          onChange={handleChange}
                        />
                        {error.email && <p className="error">{error.email}</p>}
                      </Form.Group>
                    </div>

                  </div>

                  <div className="section-title">
                    <h3>Personal Address</h3>
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          name="Personal_Address.address"
                          value={userData?.Personal_Address[0]?.address || ""}
                          onChange={handleChange}
                        />
                        {error["Personal_Address.address"] && (
                          <p className="error">
                            {error["Personal_Address.address"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Pincode</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Pincode"
                          name="Personal_Address.pincode"
                          value={userData?.Personal_Address[0]?.pincode || ""}
                          onChange={handleChange}
                        />
                        {error["Personal_Address.pincode"] && (
                          <p className="error">
                            {error["Personal_Address.pincode"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                  </div>

                  <div className="row  setInCenter">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-5"></div>
                        <div className="col-md-2">
                          {formError && (
                            <p
                              className="error"
                              style={{ textAlign: "center" }}
                            >
                              {formError}
                            </p>
                          )}
                          <button
                            type="button"
                            className="btn btnSubmit"
                            onClick={() => nextPage()}
                          >
                            Next
                          </button>
                        </div>
                        <div className="col-md-5"></div>
                      </div>
                    </div>
                  </div>
                </>
              )}
              {page === "page2" && (
                <>
                  <div className="section-title">
                    <h3>Personal Details</h3>
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Age</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter Age"
                          name="Personal_Details.age"
                          value={userData?.Personal_Details[0]?.age || ""}
                          min="0"
                          max="100"
                          onChange={handleChange}
                          onInput={(e) => {
                            if (e.target.value.length > 3) {
                              e.target.value = e.target.value.slice(0, 3);
                            }
                          }}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">Gender</Form.Label>
                        <Form.Control
                          as="select"
                          name="Personal_Details.gender"
                          value={userData?.Personal_Details[0]?.gender || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Gender</option>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                        </Form.Control>
                        {error["Personal_Details.gender"] && (
                          <p className="error">
                            {error["Personal_Details.gender"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">
                          University Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter University Name"
                          name="Personal_Details.universityName"
                          value={
                            userData?.Personal_Details[0]?.universityName || ""
                          }
                          onChange={handleChange}
                        />
                        {error["Personal_Details.universityName"] && (
                          <p className="error">
                            {error["Personal_Details.universityName"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6 row">
                      <label>Passout Year (Mention Month and year)</label>
                      <div className="col-md-5 p-1">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="MM"
                          value={month}
                          onChange={handleMonth}
                          maxLength="2"
                        />
                        {monthError && <p className="error">{monthError}</p>}
                      </div>
                      <div
                        className="col-md-1"
                        style={{
                          paddingTop: "10px",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        /
                      </div>
                      <div className="col-md-6 p-1">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="YYYY"
                          value={year}
                          onChange={handleYear}
                          maxLength="4"
                        />
                        {yearError && <p className="error">{yearError}</p>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">
                          Aadhar Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="Personal_Details.aadhar"
                          value={
                            userData?.Personal_Details[0]?.aadharNumber || ""
                          }
                          disabled={true}
                          onChange={handleChange}
                          max={new Date().toISOString().split("T")[0]}
                        />
                        {error["Personal_Details.aadhar"] && (
                          <p className="error">
                            {error["Personal_Details.aadhar"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                  <div className="row  setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page1")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page3" && (
                <>
                  <div className="section-title">
                    <h3>Office Address</h3>
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group>
                        <Form.Label className="FormLabel">
                          Occupation
                        </Form.Label>
                        <Form.Control
                          as="select"
                          name="Office_Address.occupation"
                          value={userData?.Office_Address[0]?.occupation || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Occupation</option>
                          <option value="salaried">Salaried</option>
                          <option value="selfEmployed">Self Employed</option>
                        </Form.Control>
                        {error["Office_Address.occupation"] && (
                          <p className="error">
                            {error["Office_Address.occupation"]}
                          </p>
                        )}
                      </Form.Group>
                    </div>
                    {userData?.Office_Address[0]?.occupation === "salaried" && (
                      <>
                        <div className="col-md-6">
                          <Form.Group>
                            <Form.Label className="FormLabel">
                              Designation
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Designation"
                              name="Office_Address.Designation"
                              value={
                                userData?.Office_Address[0]?.Designation || ""
                              }
                              onChange={handleChange}
                            />
                            {error["Office_Address.Designation"] && (
                              <p className="error">
                                {error["Office_Address.Designation"]}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group>
                            <Form.Label className="FormLabel">
                              Organization Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Organization Name"
                              name="Office_Address.organisationName"
                              value={
                                userData?.Office_Address[0]?.organisationName ||
                                ""
                              }
                              onChange={handleChange}
                            />
                            {error["Office_Address.organisationName"] && (
                              <p className="error">
                                {error["Office_Address.organisationName"]}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                      </>
                    )}
                    {userData?.Office_Address[0]?.occupation ===
                      "selfEmployed" && (
                        <>
                          <div className="col-md-6">
                            <Form.Group>
                              <Form.Label className="FormLabel">
                                Business Title
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Business Title"
                                name="Office_Address.bussinessTitle"
                                value={
                                  userData?.Office_Address[0]?.bussinessTitle ||
                                  ""
                                }
                                onChange={handleChange}
                              />
                              {error["Office_Address.bussinessTitle"] && (
                                <p className="error">
                                  {error["Office_Address.bussinessTitle"]}
                                </p>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group>
                              <Form.Label className="FormLabel">
                                Business Type
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Business Type"
                                name="Office_Address.businessType"
                                value={
                                  userData?.Office_Address[0]?.businessType || ""
                                }
                                onChange={handleChange}
                              />
                              {error["Office_Address.businessType"] && (
                                <p className="error">
                                  {error["Office_Address.businessType"]}
                                </p>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group>
                              <Form.Label className="FormLabel">
                                Business Address
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder="Enter Business Address"
                                name="Office_Address.bussinessAddress"
                                value={
                                  userData?.Office_Address[0]?.bussinessAddress ||
                                  ""
                                }
                                onChange={handleChange}
                              />
                              {error["Office_Address.bussinessAddress"] && (
                                <p className="error">
                                  {error["Office_Address.bussinessAddress"]}
                                </p>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-6">
                            <Form.Group>
                              <Form.Label className="FormLabel">
                                Years in Business
                              </Form.Label>
                              <Form.Control
                                type="number"
                                placeholder="Enter Years"
                                name="Office_Address.years"
                                value={userData?.Office_Address[0]?.years || ""}
                                onChange={handleChange}
                              />
                              {error["Office_Address.years"] && (
                                <p className="error">
                                  {error["Office_Address.years"]}
                                </p>
                              )}
                            </Form.Group>
                          </div>
                        </>
                      )}
                  </div>

                  <div className="row  setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page2")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page4" && (
                <>
                  <div className="section-title">
                    <h3>Family History</h3>
                  </div>

                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <h4>Reference 1 (Relative/Friend)</h4>
                      <Form.Group>
                        <Form.Label className="FormLabel">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          name="reference1.name"
                          value={
                            userData?.FamilyHistory[0]?.reference1?.name || ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference1.name"] && (
                          <p className="error">{error["reference1.name"]}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Relation</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Relation"
                          name="reference1.relation"
                          value={
                            userData?.FamilyHistory[0]?.reference1?.relation ||
                            ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference1.relation"] && (
                          <p className="error">
                            {error["reference1.relation"]}
                          </p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Phone</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter Phone"
                          name="reference1.phone"
                          value={
                            userData?.FamilyHistory[0]?.reference1?.phone || ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference1.phone"] && (
                          <p className="error">{error["reference1.phone"]}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          name="reference1.address"
                          value={
                            userData?.FamilyHistory[0]?.reference1?.address ||
                            ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference1.address"] && (
                          <p className="error">{error["reference1.address"]}</p>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <h4>Reference 2 (Government Officer)</h4>
                      <Form.Group>
                        <Form.Label className="FormLabel">Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Name"
                          name="reference2.name"
                          value={
                            userData?.FamilyHistory[0]?.reference2?.name || ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference2.name"] && (
                          <p className="error">{error["reference2.name"]}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Relation</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Relation"
                          name="reference2.relation"
                          value={
                            userData?.FamilyHistory[0]?.reference2?.relation ||
                            ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference2.relation"] && (
                          <p className="error">
                            {error["reference2.relation"]}
                          </p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Phone</Form.Label>
                        <Form.Control
                          type="number"
                          placeholder="Enter Phone"
                          name="reference2.phone"
                          value={
                            userData?.FamilyHistory[0]?.reference2?.phone || ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference2.phone"] && (
                          <p className="error">{error["reference2.phone"]}</p>
                        )}
                      </Form.Group>
                      <Form.Group>
                        <Form.Label className="FormLabel">Address</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Address"
                          name="reference2.address"
                          value={
                            userData?.FamilyHistory[0]?.reference2?.address ||
                            ""
                          }
                          onChange={handleChange}
                        />
                        {error["reference2.address"] && (
                          <p className="error">{error["reference2.address"]}</p>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                  {error["reference2.sameAsReference1"] && (
                    <p className="error">
                      {error["reference2.sameAsReference1"]}
                    </p>
                  )}
                  <div className="row setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page3")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page5" && (
                <>
                  <div className="doc-upload-header">
                    <h3>Preferred Regions</h3>
                    <button
                      type="button"
                      className="add-doc-btn"
                      onClick={() =>
                        setUserData({
                          ...userData,
                          PreferredRegions: [
                            ...userData.PreferredRegions,
                            { pincode: "", region: "" },
                          ],
                        })
                      }
                      disabled={uploadFileLoader}
                      aria-label="Add Document"
                    >
                      <SquarePlus size={26} style={{ color: '#059669' }} />
                      <span className="doc-tooltip">
                        Add Region
                      </span>
                    </button>
                  </div>

                  <hr />
                  <div className="preferred-regions">

                    {userData?.PreferredRegions.map((regionData, index) => (
                      <div className="row" key={index}>
                        <div className="col-md-5">
                          <Form.Group>
                            <Form.Label className="FormLabel">
                              Pincode
                            </Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="Enter Pincode"
                              name={`pincodePreferredRegions[${index}]`}
                              value={regionData?.pincode || ""}
                              onChange={(e) =>
                                handlePreferredRegionsChange(e, index)
                              }
                            />

                            {error[`PreferredRegions[${index}].pincode`] && (
                              <p className="error">
                                {error[`PreferredRegions[${index}].pincode`]}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-5">
                          <Form.Group>
                            <Form.Label className="FormLabel">
                              Region
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Enter Region"
                              name={`regionPreferredRegions[${index}]`}
                              value={regionData?.region || ""}
                              onChange={(e) =>
                                handlePreferredRegionsChange(e, index)
                              }
                            />

                            {error[`PreferredRegions[${index}].region`] && (
                              <p className="error">
                                {error[`PreferredRegions[${index}].region`]}
                              </p>
                            )}
                          </Form.Group>
                        </div>
                        <div className="col-md-2">
                          <p
                            className="removeIcons2"
                            onClick={() => handleRemoveRegion(index)}
                          >
                            X
                          </p>
                        </div>
                      </div>
                    ))}

                  </div>
                  <br />
                  <div className="row  setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page4")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnSubmit"
                        onClick={() => nextPage()}
                      >
                        {/* {isLoading ? "Submitting..." : "Submit"} */}
                        Next
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>
              )}
              {page === "page6" && (
                <>
                  <div className="doc-upload-header">
                    <h3>Documents</h3>
                    <button
                      type="button"
                      className="add-doc-btn"
                      onClick={() => fileInputRef.current.click()}
                      disabled={uploadFileLoader}
                      aria-label="Add Document"
                    >
                      <SquarePlus size={26} style={{ color: '#059669' }} />
                      <span className="doc-tooltip">
                        {uploadFileLoader ? "Uploading Document..." : "Add New Document"}
                      </span>
                    </button>
                  </div>

                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: "none" }}
                    ref={fileInputRef}
                    onChange={handleFileUpload}
                  />

                  {uploadedFiles.length > 0 ? (
                    <div className="doc-grid">
                      {uploadedFiles.map((x, index) => (
                        <div className="doc-card" key={index}>
                          <div className="doc-card-header">
                            <span className="doc-card-title">{x.docName}</span>
                            <button
                              className="remove-doc-btn"
                              onClick={() => handleRemove(index)}
                              aria-label="Remove"
                            >
                              <X size={20} />
                              <span className="doc-tooltip">Remove</span>
                            </button>
                          </div>
                          <div className="doc-card-preview">
                            <DocumentPreview
                              url={x?.url}
                              title={`Document ${index + 1}`}
                              className="doc-iframe"
                              showActions={true}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="no-docs-msg">
                      <p>No uploaded documents found.</p>
                    </div>
                  )}

                  <div className="row  setInCenter">
                    {formError && (
                      <p className="error" style={{ textAlign: "center" }}>
                        {formError}
                      </p>
                    )}
                    <div className="col-md-2"></div>
                    <div className="col-md-2">
                      <button
                        type="button"
                        className="btn btnprev"
                        onClick={() => setPage("page5")}
                      >
                        Previous
                      </button>
                    </div>
                    <div className="col-md-2">
                      <button
                        type="submit"
                        className="btn btnSubmit"
                        disabled={uploadFileLoader}
                      >
                        {isLoading ? "Submitting..." : "Submit"}
                      </button>
                    </div>
                    <div className="col-md-2"></div>
                  </div>
                </>

              )}
            </Form>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={2000} />
    </div>
  );
};

export default ProfileEdit;
